import React, { useState } from "react";
import PageContext from "./PageContext";

const PageProvider = ({ children, ...props }) => {
  const pageContextHook = useState({});
  return <PageContext.Provider value={pageContextHook}>{children}</PageContext.Provider>;
};

export default PageProvider;
